import React from "react";

export const AI_POPUP_TAB_IDS = {
  aiManagement: "aiManagement",
  sqftAiManagement: "sqftAiManagement",
};

export const AI_POPUP_TABS = [{
  id: AI_POPUP_TAB_IDS.aiManagement,
  label: "AI Management",
}, {
  id: AI_POPUP_TAB_IDS.sqftAiManagement,
  label: "SQFT AI Management",
}];

/**
 * Tab bar of the AI dev popup. There is no shared tab component in the app, so the active
 * state is drawn with the existing utility classes plus an underline on the active tab.
 */
const UiPopupAIContentTabs = (props) => {

  const {activeTab, onTabClick} = props;

  return (
    <div className="flex flex--start u-mb-15" style={{borderBottom: "1px solid #d8d8d8"}}>
      {AI_POPUP_TABS.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button key={tab.id}
                  type="button"
                  className={"u-pl-1 u-pr-1 u-pt-05 u-pb-05 bold text-uppercase nowrap "
                    + (isActive ? "color-active" : "color-primary")}
                  style={{
                    background: "none",
                    border: "none",
                    borderBottom: "3px solid " + (isActive ? "currentColor" : "transparent"),
                    marginBottom: "-1px",
                    cursor: "pointer",
                  }}
                  onClick={() => onTabClick(tab.id)}>
            {tab.label}
          </button>
        )
      })}
    </div>
  )
};

export default UiPopupAIContentTabs
